import { z } from 'zod';

interface PersonalDetailsFormLabels {
  firstName: string;
  lastName: string;
  emailRequired: string;
  emailValid: string;
  phoneNumber: string;
  streetAddress: string;
}

const personalDetailsFormSchema = (formLabels: PersonalDetailsFormLabels) =>
  z.object({
    email: z.preprocess(
      val => (typeof val === 'string' ? val.trim() : val),
      z.string().min(1, formLabels.emailRequired).email(formLabels.emailValid)
    ),
    firstName: z.string().min(1, formLabels.firstName),
    lastName: z.string().min(1, formLabels.lastName),
    phoneNumber: z
      .string()
      .regex(/^\+?1?\s*(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/, {
        message: formLabels.phoneNumber,
      }),
    streetAddress: z.string().min(1, formLabels.streetAddress),
    postalCode: z.string().optional(),
    referralCode: z.string().optional(),
  });

const dealerSelectFormSchema = (dealerLabel: string) =>
  z.object({
    dealer: z.string().nonempty(dealerLabel),
  });

export {
  personalDetailsFormSchema,
  dealerSelectFormSchema,
  PersonalDetailsFormLabels,
};
